/**
 * DOM ids for {@link UnitNumberInput} fields in {@link StoreySettingsPanel}.
 * Keep in sync with hotkey focus logic.
 */
export const getStoreyHeightInputId = (storeyId: string): string =>
  `storey-height-${storeyId}`;

export const getStoreyElevationInputId = (storeyId: string): string =>
  `storey-elevation-${storeyId}`;

export const getStoreyMezzanineElevationInputId = (storeyId: string): string =>
  `storey-mezzanine-elevation-${storeyId}`;
